module.exports = __webpack_public_path__ + "img/2.729c63c0.svg";